import appIconGwxzl from '@/assets/image/icon/app-gwxzl.png'
import appIconGwxzs from '@/assets/image/icon/app-gwxzs.png'
import appIconBadou from '@/assets/image/icon/app-badou.png'
import appIconSvg from '@/assets/image/icon/app-icon.svg?url'

const APP_ICON_SOURCES = {
  'app-gwxzl.png': appIconGwxzl,
  'app-gwxzs.png': appIconGwxzs,
  'app-badou.png': appIconBadou,
  'app-icon.svg': appIconSvg
} as const

/** 应用图标（由 VITE_APP_ICON 指定 assets/image/icon 下的文件名） */
export const APP_ICON =
  APP_ICON_SOURCES[import.meta.env.VITE_APP_ICON as keyof typeof APP_ICON_SOURCES] ??
  appIconGwxzl

/** 当前应用图标是否为 PNG（用于差异化样式，如白边描边） */
export const APP_ICON_IS_PNG = import.meta.env.VITE_APP_ICON?.endsWith('.png') ?? true

/** 面向用户的应用展示名称（如页面标题、品牌文案） */
export const APP_DISPLAY_NAME = import.meta.env.VITE_APP_DISPLAY_NAME || '公文小助理'

/** 运营主体公司名称 */
export const COMPANY_NAME = import.meta.env.VITE_COMPANY_NAME || '广州禄马信息科技有限公司'

/** 客服/联系电话 */
export const CONTACT_PHONE = import.meta.env.VITE_CONTACT_PHONE || '19100783859'

/** 客服/联系邮箱 */
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL || 'lidai@gzluma.top'

/** 公司联系地址 */
export const CONTACT_ADDRESS =
  import.meta.env.VITE_CONTACT_ADDRESS || '广州市番禺区洛浦街道南桂路6号华域·岭居616房'

/** ICP 备案号（官网页脚展示） */
export const ICP_FILING = import.meta.env.VITE_ICP_FILING || '粤ICP备2024256324号-6'

/** 官网域名（展示用，不含协议，如 www.gwxzl.com） */
export const OFFICIAL_WEBSITE = import.meta.env.VITE_OFFICIAL_WEBSITE || 'www.gwxzl.com'

/** 生成「页面名 - 应用名」格式的 document.title */
export function withAppName(pageTitle: string): string {
  return `${pageTitle} - ${APP_DISPLAY_NAME}`
}
